import React, { useState } from "react";
import LinkSlider from "../Components/LinkSlider";
// import OurSolutionBanner from "../Components/OurSolutionBanner";
import { motion } from "framer-motion";
import PeopleSafetyExecution from "../Components/PeopleSafetyExecution";
import Faq from "../Components/Faq";
import Contactus from "../Components/Contactus";
import { SubscribeSection } from "../Components/SubscribeSection";
import { useLanguage } from "../Router/LanguageContext";

export default function OilGas() {
  const [activeTab, setActiveTab] = useState("wellinter");
  const [videoLoaded, setVideoLoaded] = useState(false);

  const { dictionary } = useLanguage();

  const wellinterArray = {
    title: dictionary?.wellInterventionTitle,
    description: dictionary?.wellInterventionDesc,
    keycapabilities: dictionary?.keyCapabilities,
    arrayData: dictionary?.wellInterventionPoints || [],
  };

  const wellcompletionArray = {
    title: dictionary?.wellCompletionTitle,
    description: dictionary?.wellCompletionDesc,
    keycapabilities: dictionary?.keyCapabilities,
    arrayData: dictionary?.wellCompletionPoints || [],
  };

  const chemicalsuppliesArray = {
    title: dictionary?.chemicalSuppliesTitle,
    description: dictionary?.chemicalSuppliesDesc,
    keycapabilities: dictionary?.keyCapabilities,
    arrayData: dictionary?.chemicalSuppliesPoints || [],
  };

  const maritimesupplyArray = {
    title: dictionary?.maritimeSupplyTitle,
    description: dictionary?.maritimeSupplyDesc,
    keycapabilities: dictionary?.keyCapabilities,
    arrayData: dictionary?.maritimeSupplyPoints || [],
  };

  const specializedmanpowerArray = {
    title: dictionary?.specializedManpowerTitle,
    description: dictionary?.specializedManpowerDesc,
    keycapabilities: dictionary?.keyCapabilities,
    arrayData: dictionary?.specializedManpowerPoints || [],
  };

  return (
    <>
      {/* <OurSolutionBanner
        title="Powering upstream performance"
        description="Comprehensive well services, chemical solutions, maritime logistics, and specialized manpower delivering operational excellence across onshore and offshore environments."
        button="Request a consultation"
        bgImage="/assets/img/OilGasBanner1.png"
        redirect="/contact-us"
      /> */}
      <div className="heroSectionBgVideoWrapper">
        {!videoLoaded && (
          <img
            src="/assets/img/oilgasVideoBanner.png"
            alt=""
            className="bgVideo"
          />
        )}
        <video
          className={`bgVideo ${videoLoaded ? "showVideo" : "hideVideo"}`}
          autoPlay
          muted
          loop
          playsInline
          onLoadedData={() => setVideoLoaded(true)}
        >
          <source src="/assets/video/oil_service.mp4" type="video/mp4" />
        </video>
        <div className="heroSectionContentOuter">
          <div className="container-fluid maxContainerSection">
            <div className="row heroSectionContent">
              <div className="col-md-12 heroLeftSection aboutTextCenter">
                <h2 className="m-0 f-s-48"> {dictionary?.upstreamHeroTitle}</h2>
                <p className="m-0 f-s-20">{dictionary?.upstreamHeroDesc}</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <LinkSlider />

      <div className="integratedCleanSection">
        <div className="container-fluid maxContainerSection commonPadding">
          <div className="row">
            <div className="col-md-12 whowearehedaersection ourSolutionSectionHeader">
              <h2 className="m-0 f-s-48">{dictionary?.upstreamTitle}</h2>
              <p className="m-0 f-s-20">{dictionary?.upstreamDesc}</p>
            </div>
          </div>

          <div className="row">
            <div className="col-md-12 switchIntegratedOuter">
              <div className="switchIntegrated">
                <div
                  className={`switchIntegratedInner ${
                    activeTab === "wellinter"
                      ? "switchIntegratedInnerActive"
                      : ""
                  }`}
                  onClick={() => setActiveTab("wellinter")}
                >
                  <p className="m-0 f-s-20">
                    {dictionary?.wellInterventionTitle}
                  </p>
                </div>

                <div
                  className={`switchIntegratedInner ${
                    activeTab === "wellcompletion"
                      ? "switchIntegratedInnerActive"
                      : ""
                  }`}
                  onClick={() => setActiveTab("wellcompletion")}
                >
                  <p className="m-0 f-s-20">
                    {dictionary?.wellCompletionTitle}
                  </p>
                </div>

                <div
                  className={`switchIntegratedInner ${
                    activeTab === "chemicalsupplies"
                      ? "switchIntegratedInnerActive"
                      : ""
                  }`}
                  onClick={() => setActiveTab("chemicalsupplies")}
                >
                  <p className="m-0 f-s-20">
                    {dictionary?.chemicalSuppliesTitle}
                  </p>
                </div>

                <div
                  className={`switchIntegratedInner ${
                    activeTab === "maritimesupply"
                      ? "switchIntegratedInnerActive"
                      : ""
                  }`}
                  onClick={() => setActiveTab("maritimesupply")}
                >
                  <p className="m-0 f-s-20">
                    {dictionary?.maritimeSupplyTitle}
                  </p>
                </div>
                <div
                  className={`switchIntegratedInner ${
                    activeTab === "specializedmanpower"
                      ? "switchIntegratedInnerActive"
                      : ""
                  }`}
                  onClick={() => setActiveTab("specializedmanpower")}
                >
                  <p className="m-0 f-s-20">
                    {dictionary?.specializedManpowerTitle}
                  </p>
                </div>
              </div>
            </div>
          </div>
          {activeTab === "wellinter" && (
            <div className="row tabSectionInner">
              <div className="col-md-6">
                <motion.img
                  src="/assets/img/Bioenergybiofuelsnew.png"
                  className="img-fluid"
                  initial={{ opacity: 0, scale: 0.8 }}
                  whileInView={{ opacity: 1, scale: 1 }}
                  transition={{ duration: 0.6, delay: 0.4 }}
                  viewport={{ once: true }}
                />
              </div>
              <div className="col-md-6 tabSectionInnerRight">
                <motion.h3
                  className="mission-title m-0 f-s-48"
                  initial={{ opacity: 0, y: 40 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.6 }}
                  viewport={{ once: true }}
                >
                  {wellinterArray.title}
                </motion.h3>
                <motion.p
                  className="mission-text m-0 f-s-20"
                  initial={{ opacity: 0, y: 40 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.6, delay: 0.2 }}
                  viewport={{ once: true }}
                >
                  {wellinterArray?.description}
                </motion.p>

                <motion.h6
                  className="f-s-20 m-0 keyCapabilities"
                  initial={{ opacity: 0, y: 40 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.6 }}
                  viewport={{ once: true }}
                >
                  {wellinterArray.keycapabilities}
                </motion.h6>
                <img src="/assets/img/Line.svg" alt="" className="img-fluid" />
                {wellinterArray?.arrayData?.map((item, i) => (
                  <motion.div
                    key={i}
                    initial={{ opacity: 0, x: 30 }}
                    whileInView={{ opacity: 1, x: 0 }}
                    transition={{ duration: 0.4, delay: 0.4 + i * 0.15 }}
                    viewport={{ once: true }}
                  >
                    <div className="energysectionpoints f-s-18">
                      <img src="/assets/img/tickIcon.svg" alt="" /> {item}
                    </div>
                  </motion.div>
                ))}
              </div>
            </div>
          )}

          {activeTab === "wellcompletion" && (
            <div className="row tabSectionInner">
              <div className="col-md-6">
                <div className="mission-image-wrapper">
                  <motion.img
                    src="/assets/img/WellcompletionNew.png"
                    className="img-fluid"
                    initial={{ opacity: 0, scale: 0.8 }}
                    whileInView={{ opacity: 1, scale: 1 }}
                    transition={{ duration: 0.6, delay: 0.4 }}
                    viewport={{ once: true }}
                  />

                  {/* <motion.img
                    className="value-img-main"
                    src="/assets/img/Wellcompletionmain.png"
                    alt=""
                    initial={{ opacity: 0 }}
                    whileInView={{ opacity: 1, x: 0 }}
                    transition={{ duration: 0.8 }}
                    viewport={{ once: true }}
                  />
                  <motion.img
                    className="value-img-left box-img-common-style EnergyefficiencyBottom"
                    src="/assets/img/WellcompletionBottom.png"
                    alt=""
                    initial={{ opacity: 0, scale: 0.85 }}
                    whileInView={{ opacity: 1, scale: 1 }}
                    whileHover={{
                      scale: 1.03,
                      transition: { duration: 0.25, ease: "easeIn" },
                    }}
                    transition={{ duration: 1, ease: "easeInOut" }}
                    viewport={{ once: true }}
                  />
                  <motion.img
                    className="value-img-right box-img-common-style EnergyefficiencyHeadImage"
                    src="/assets/img/WellcompletionUpper.png"
                    alt=""
                    initial={{ opacity: 0, scale: 0.85 }}
                    whileInView={{ opacity: 1, scale: 1 }}
                    whileHover={{
                      scale: 1.03,
                      transition: { duration: 0.25, ease: "easeIn" },
                    }}
                    transition={{ duration: 1, ease: "easeInOut" }}
                    viewport={{ once: true }}
                  /> */}
                </div>
              </div>
              <div className="col-md-6 tabSectionInnerRight">
                <motion.h3
                  className="mission-title m-0 f-s-48"
                  initial={{ opacity: 0, y: 40 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.6 }}
                  viewport={{ once: true }}
                >
                  {wellcompletionArray.title}
                </motion.h3>
                <motion.p
                  className="mission-text m-0 f-s-20"
                  initial={{ opacity: 0, y: 40 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.6, delay: 0.2 }}
                  viewport={{ once: true }}
                >
                  {wellcompletionArray?.description}
                </motion.p>

                <motion.h6
                  className="f-s-20 m-0 keyCapabilities"
                  initial={{ opacity: 0, y: 40 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.6 }}
                  viewport={{ once: true }}
                >
                  {wellcompletionArray.keycapabilities}
                </motion.h6>
                <img src="/assets/img/Line.svg" alt="" className="img-fluid" />
                {wellcompletionArray?.arrayData?.map((item, i) => (
                  <motion.div
                    key={i}
                    initial={{ opacity: 0, x: 30 }}
                    whileInView={{ opacity: 1, x: 0 }}
                    transition={{ duration: 0.4, delay: 0.4 + i * 0.15 }}
                    viewport={{ once: true }}
                  >
                    <div className="energysectionpoints f-s-18">
                      <img src="/assets/img/tickIcon.svg" alt="" /> {item}
                    </div>
                  </motion.div>
                ))}
              </div>
            </div>
          )}

          {activeTab === "chemicalsupplies" && (
            <div className="row tabSectionInner">
              <div className="col-md-6">
                <motion.img
                  src="/assets/img/ChemicalsuppliesNew.png"
                  className="img-fluid"
                  initial={{ opacity: 0, scale: 0.8 }}
                  whileInView={{ opacity: 1, scale: 1 }}
                  transition={{ duration: 0.6, delay: 0.4 }}
                  viewport={{ once: true }}
                />
              </div>
              <div className="col-md-6 tabSectionInnerRight">
                <motion.h3
                  className="mission-title m-0 f-s-48"
                  initial={{ opacity: 0, y: 40 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.6 }}
                  viewport={{ once: true }}
                >
                  {chemicalsuppliesArray.title}
                </motion.h3>
                <motion.p
                  className="mission-text m-0 f-s-20"
                  initial={{ opacity: 0, y: 40 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.6, delay: 0.2 }}
                  viewport={{ once: true }}
                >
                  {chemicalsuppliesArray?.description}
                </motion.p>

                <motion.h6
                  className="f-s-20 m-0 keyCapabilities"
                  initial={{ opacity: 0, y: 40 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.6 }}
                  viewport={{ once: true }}
                >
                  {chemicalsuppliesArray.keycapabilities}
                </motion.h6>
                <img src="/assets/img/Line.svg" alt="" className="img-fluid" />
                {chemicalsuppliesArray?.arrayData?.map((item, i) => (
                  <motion.div
                    key={i}
                    initial={{ opacity: 0, x: 30 }}
                    whileInView={{ opacity: 1, x: 0 }}
                    transition={{ duration: 0.4, delay: 0.4 + i * 0.15 }}
                    viewport={{ once: true }}
                  >
                    <div className="energysectionpoints f-s-18">
                      <img src="/assets/img/tickIcon.svg" alt="" /> {item}
                    </div>
                  </motion.div>
                ))}
              </div>
            </div>
          )}

          {activeTab === "maritimesupply" && (
            <div className="row tabSectionInner">
              <div className="col-md-6 imgTabSection">
                <motion.img
                  src="/assets/img/MaritimesupplyNew.png"
                  className="img-fluid"
                  initial={{ opacity: 0, scale: 0.8 }}
                  whileInView={{ opacity: 1, scale: 1 }}
                  transition={{ duration: 0.6, delay: 0.4 }}
                  viewport={{ once: true }}
                />
              </div>
              <div className="col-md-6 tabSectionInnerRight">
                <motion.h3
                  className="mission-title m-0 f-s-48"
                  initial={{ opacity: 0, y: 40 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.6 }}
                  viewport={{ once: true }}
                >
                  {maritimesupplyArray.title}
                </motion.h3>
                <motion.p
                  className="mission-text m-0 f-s-20"
                  initial={{ opacity: 0, y: 40 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.6, delay: 0.2 }}
                  viewport={{ once: true }}
                >
                  {maritimesupplyArray?.description}
                </motion.p>

                <motion.h6
                  className="f-s-20 m-0 keyCapabilities"
                  initial={{ opacity: 0, y: 40 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.6 }}
                  viewport={{ once: true }}
                >
                  {maritimesupplyArray.keycapabilities}
                </motion.h6>
                <img src="/assets/img/Line.svg" alt="" className="img-fluid" />
                {maritimesupplyArray?.arrayData?.map((item, i) => (
                  <motion.div
                    key={i}
                    initial={{ opacity: 0, x: 30 }}
                    whileInView={{ opacity: 1, x: 0 }}
                    transition={{ duration: 0.4, delay: 0.4 + i * 0.15 }}
                    viewport={{ once: true }}
                  >
                    <div className="energysectionpoints f-s-18">
                      <img src="/assets/img/tickIcon.svg" alt="" /> {item}
                    </div>
                  </motion.div>
                ))}
              </div>
            </div>
          )}

          {activeTab === "specializedmanpower" && (
            <div className="row tabSectionInner">
              <div className="col-md-6">
                <motion.img
                  src="/assets/img/Specializedmanpower.png"
                  className="img-fluid"
                  initial={{ opacity: 0, scale: 0.8 }}
                  whileInView={{ opacity: 1, scale: 1 }}
                  transition={{ duration: 0.6, delay: 0.4 }}
                  viewport={{ once: true }}
                />
              </div>
              <div className="col-md-6 tabSectionInnerRight">
                <motion.h3
                  className="mission-title m-0 f-s-48"
                  initial={{ opacity: 0, y: 40 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.6 }}
                  viewport={{ once: true }}
                >
                  {specializedmanpowerArray.title}
                </motion.h3>
                <motion.p
                  className="mission-text m-0 f-s-20"
                  initial={{ opacity: 0, y: 40 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.6, delay: 0.2 }}
                  viewport={{ once: true }}
                >
                  {specializedmanpowerArray?.description}
                </motion.p>

                <motion.h6
                  className="f-s-20 m-0 keyCapabilities"
                  initial={{ opacity: 0, y: 40 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.6 }}
                  viewport={{ once: true }}
                >
                  {specializedmanpowerArray.keycapabilities}
                </motion.h6>
                <img src="/assets/img/Line.svg" alt="" className="img-fluid" />
                {specializedmanpowerArray?.arrayData?.map((item, i) => (
                  <motion.div
                    key={i}
                    initial={{ opacity: 0, x: 30 }}
                    whileInView={{ opacity: 1, x: 0 }}
                    transition={{ duration: 0.4, delay: 0.4 + i * 0.15 }}
                    viewport={{ once: true }}
                  >
                    <div className="energysectionpoints f-s-18">
                      <img src="/assets/img/tickIcon.svg" alt="" /> {item}
                    </div>
                  </motion.div>
                ))}
              </div>
            </div>
          )}
        </div>
      </div>
      <PeopleSafetyExecution />
      <div className="section-main-contact-us">
        <div className="container-fluid maxContainerSection commonPadding pb-0">
          <div className="row">
            <div className="col-md-12 whowearehedaersection ourSolutionSectionHeader">
              <h2 className="m-0 f-s-48">{dictionary?.getInTouchTitle}</h2>
              <p className="m-0 f-s-20 ">
                {dictionary?.getInTouchDesc}
              </p>
            </div>
          </div>
          <Contactus />
        </div>
      </div>
      <Faq />
      <SubscribeSection />
    </>
  );
}
